import { t } from "./i18n";

// Slice 2 end-of-flow confirmation. The determination is intentionally NOT shown on screen and there
// is no download: it reaches the family only in the emailed PDF that Big Bend also receives.
export function renderConfirmation(container: HTMLElement, onRestart: () => void): void {
  while (container.firstChild) container.removeChild(container.firstChild);

  const wrapper = document.createElement("div");
  wrapper.className = "questionnaire";

  const heading = document.createElement("h2");
  heading.className = "question-text";
  heading.textContent = t("ui.sent.title");
  wrapper.appendChild(heading);

  const message = document.createElement("p");
  message.className = "help-text";
  message.textContent = t("ui.sent.message");
  wrapper.appendChild(message);

  const restartBtn = document.createElement("button");
  restartBtn.type = "button";
  restartBtn.className = "btn-secondary";
  restartBtn.textContent = t("ui.sent.restart");
  restartBtn.addEventListener("click", onRestart);
  wrapper.appendChild(restartBtn);

  container.appendChild(wrapper);
}
